// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","socialLinks":"Footer_socialLinks__7BvBL","socialIcon":"Footer_socialIcon__vNbla","copyright":"Footer_copyright__QJwUC"};